import React from "react";
import { motion } from "framer-motion";
import { LineReveal, Kicker } from "./Reveal";

export const PageHero = ({ kicker, lines, intro, meta }) => (
  <section className="relative bg-[#0A2B3D] text-white overflow-hidden" data-testid="page-hero">
    <motion.div
      aria-hidden="true"
      className="absolute inset-0 opacity-[0.06]"
      style={{
        backgroundImage: "linear-gradient(#A9CFE2 1px, transparent 1px), linear-gradient(90deg, #A9CFE2 1px, transparent 1px)",
        backgroundSize: "72px 72px",
      }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 0.06 }}
      transition={{ duration: 1.4 }}
    />
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8 md:px-12 py-24 md:py-32">
      <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.1 }}>
        <Kicker light>{kicker}</Kicker>
      </motion.div>
      <h1 className="mt-6 font-serif font-bold text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.08] max-w-4xl">
        <LineReveal lines={lines} />
      </h1>
      {intro && (
        <motion.p
          className="mt-8 max-w-2xl text-base md:text-lg text-white/75 leading-relaxed"
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.7 }}
        >
          {intro}
        </motion.p>
      )}
      {meta && (
        <motion.div
          className="mt-10 flex flex-wrap gap-x-8 gap-y-3 font-mono text-xs uppercase tracking-[0.2em] text-[#A9CFE2]"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.95 }}
        >
          {meta.map((m) => <span key={m}>{m}</span>)}
        </motion.div>
      )}
    </div>
  </section>
);
